import { useState } from 'react'
import { Icon } from 'packages/eid-icons'
import { Button, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'

const CancelButton = ({ onClick, disabled, showEndIcon = false, styles }) => {
    const { t } = useTranslation()
    const [actionsButtonIconColor, setActionsButtonIconColor] =
        useState('#215197')
    const theme = useTheme()

    return (
        <Button
            disabled={disabled}
            onClick={onClick}
            onMouseEnter={() => {
                setActionsButtonIconColor('white')
            }}
            onMouseLeave={() => {
                setActionsButtonIconColor('#215197')
            }}
            disabledStyles={{}}
            sx={{
                position: 'relative',
                height: '48px',
                maxWidth: '120px',
                width: '120px',
                padding: '8px 12px',
                borderRadius: '4px',
                boxShadow: '0 0 0 0',
                textTransform: 'capitalize',
                lineHeight: 'initial',
                backgroundColor: 'transparent',
                border: `solid 1px ${theme?.palette?.primary?.main}`,

                color: theme?.palette?.primary?.main,
                '&:hover': {
                    backgroundColor: theme?.palette?.primary?.main,
                    color: 'white',
                    cursor: 'hand',
                },
                ...styles,
                '&.Mui-disabled': {
                    backgroundColor: '#efeff1 !important',
                    color: '#8b909a !important',
                    border: 'solid 1px #8b909a !important',
                },
            }}
            endIcon={
                showEndIcon && (
                    <Icon
                        name="DeleteX"
                        style={{ width: '6px', height: '6px' }}
                        color={disabled ? '#8b909a' : actionsButtonIconColor}
                        fill={disabled ? '#8b909a' : actionsButtonIconColor}
                    />
                )
            }
        >
            {t('Cancel')}
        </Button>
    )
}

export default CancelButton
